import React, { FC } from 'react';
import { VideoToolStrings } from '../../../localization/en';
import {
  StyledContainer,
  RecordButton,
  UploadButton,
} from './CreateVideoControls.styles';
import { PortalWrapper } from '../../PortalWrapper/PortalWrapper';

interface Props {
  handleCaptureClick: () => void;
  handleInputClick: (event: React.MouseEvent<HTMLElement>) => void;
  isButtonsDisabled: boolean;
}

export const CreateVideoControls: FC<Props> = ({ handleCaptureClick, handleInputClick, isButtonsDisabled }) => {
  return (
    <PortalWrapper offset={14}>
      <StyledContainer>
        <RecordButton
          onClick={handleCaptureClick}
          disabled={isButtonsDisabled}
        >
          {VideoToolStrings.RecordVideo}
        </RecordButton>
        <UploadButton
          onClick={handleInputClick}
          disabled={isButtonsDisabled}
        >
          {VideoToolStrings.UploadAVideo}
        </UploadButton>
      </StyledContainer>
    </PortalWrapper>
  );
};
